import * as React from 'react';
import styled from 'styled-components';
import { INotificationInfo } from '../notification-types';
import { IBaseComponentProps } from '../../types';
import { Typography } from '../../typography';

interface INotificationItemMessageProps extends Pick<INotificationInfo, 'type' | 'message' | 'additionalInfo'>, IBaseComponentProps {
}

const AdditionalInfoContent = styled(Typography.XSmall).attrs(() => ({
    className: String('ap-notificationMessageAdditionalInfo')
}))`
    margin-top: ${({ theme: { semantics: { gap } } }) => gap.l};
    max-height: 140px;
    overflow: hidden;
    display: block;
`;

const ReadMoreInfo = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    top: 115px;
    width: 100%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgb(255, 255, 255));
`;

const StyledSpan = styled.span<{$additionalInfo?: boolean}>`
    width: fit-content;
    cursor: text;
    font-weight: ${({$additionalInfo}) => ($additionalInfo ? '600' : '400')};
`;

function NotificationItemMessageBase(props: INotificationItemMessageProps) {
    const { message, additionalInfo, className } = props;
    return (
        <div className={className}>
            <Typography.Small>
                <StyledSpan $additionalInfo={!!additionalInfo}>{message}</StyledSpan>
                {additionalInfo ? (
                    <AdditionalInfoContent>
                        <StyledSpan>
                            {additionalInfo}
                        </StyledSpan>
                    </AdditionalInfoContent>
                ) : null}
                <ReadMoreInfo />
            </Typography.Small>
        </div>
    );
}

export const NotificationItemMessage = styled(NotificationItemMessageBase).attrs(() => ({
    className: String('ap-notificationMessageHeader')
}))<INotificationItemMessageProps>`
    width: calc(100% - 47px);
    display: inline-block;
`;
